import React, { useContext, useCallback, useState, useEffect } from 'react'
import AsyncSelect from 'react-select/async';
import { components } from 'react-select';
import classNames from "classnames";
import { ResponsiveSize, ValidationState } from 'acma-spa/dist/Types';
import { reactSelectStyles } from 'acma-spa/dist/pickers/PickerStyles';
import { GroupContext, LabelContext } from 'acma-spa';
import styles from "acma-spa/dist/pickers/PickerStyles.scss";
import { ClientApiProps } from './ClientApiProps';
import { Hint, IAlphaTag, IFilter, getApiClient } from '../api';
import { AlphaTagStore } from '../stores/AlphaTagStore';
import { RegisterStore } from '../stores/RegisterStore';

export interface AlphaTagPickerProps extends ClientApiProps {
  /**
   * Control id
   */
  id?: string;

  /**
   * Control value
   */
  value: IAlphaTag[];

  /**
   * Trigger OnChnage
   */
  onChange: (v: IAlphaTag[]) => void;

  /**
   * Control size
   */
  size?: ResponsiveSize;

  /**
   * Control state
   */
  state?: ValidationState;

  /**
   * Trigger disabled
   */
  disabled?: boolean;

  /**
   * Custom class name
   */
  className?: string;

  /**
   * Options
   */
  defaultOptions?: IAlphaTag[]

  /**
   * Register support
   */
  register?: boolean
}

export const AlphaTagPicker: React.FC<AlphaTagPickerProps> = ({ size = 'block', ...props }) => {

  const labelCtx = useContext(LabelContext);
  const groupCtx = useContext(GroupContext);
  const state = labelCtx.state || props.state;

  const getOptions = async (s: string) => {

    const [client, abort] = getApiClient(
      props.baseUrl,
      props.b2cDomainName,
      props.msalClient
    );

    if (props.register) {
      const store = new RegisterStore(client);
      return await store.getRegisteredAlphaTags(undefined, undefined, undefined, undefined, s, Hint.Name, false, 1, 10);
    }
    else {
      const store = new AlphaTagStore(client);
      return (await store.getAlphaTags(undefined, undefined, undefined, s, Hint.Name, false, 1, 10, [])).filter(i => i.mnoId == null);
    }
  }

  return <div className={classNames(styles["au-picker"], {
    [styles[`au-picker--width-${size}`]]: size && size != 'block',
    [styles[`au-picker--block`]]: size == 'block'
  }, groupCtx.className, props.className)}>
    <AsyncSelect<IAlphaTag, true>
      isMulti={true}
      inputId={props.id || labelCtx.id}
      styles={reactSelectStyles(state)}
      className={classNames(groupCtx.className, props.className)}
      placeholder="Enter alpha tags..."
      loadOptions={s => getOptions(s)}
      value={props.value}
      onChange={v => props.onChange(v.slice())}
      getOptionLabel={r => r.name ?? ""}
      getOptionValue={r => r.alphaTagId ?? ""}
      isClearable
      isDisabled={props.disabled}
      cacheOptions={false}
      defaultOptions={props.defaultOptions}
      components={{
        MultiValueContainer: props => {
          return <div title={`${props.data.name} - ${props.data.clientName}`}>
            <components.MultiValueContainer {...props} />
          </div>
        },
        Option: props => <components.Option {...props}>
          {props.data.name} - {props.data.clientName}
        </components.Option>
      }}
    />
  </div>
}
